import React, { Component } from "react";
import Box from "@mui/material/Box";
import {
  Avatar,
  Button,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { fetchDashboard } from "./API";
import ArticleIcon from "@mui/icons-material/Article";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import IconButton from "@mui/material/IconButton";
import sale1 from "../images/sale1.png";
import sale2 from "../images/sale2.png";
import sale3 from "../images/sale3.png";
import purchase1 from "../images/purchase1.png";
import purchase2 from "../images/purchase2.png";
import purchase3 from "../images/purchase3.png";
import { withRouter } from "../HOC/withRouter";
import Card from "@mui/material/Card";
import { connect } from "react-redux";
import {
  mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import Progress from "./CustomTool/Progress";
import CompanyList from "./CompanyList";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCReduxData from "../HOC/HOCReduxData";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import SalesList from "./SalesList";

class Dashboard extends Component {
  state = {
    dataLoadStatus: true,
    ARD: null,
    cmbAccountYear: [],
    selection: {
      year: "",
      company: "",
      GstNo: "",
    },
    SalesData: {
      PendingInvoice: 0,
      TotalInvoice: 0,
    },
    PurchaseData: {
      PendingInvoice: 0,
      TotalInvoice: 0,
    },
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Dashboard";
    this.props.setActiveMenu("Dashboard");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handle
  handleOnChangleProgressBarStatus = (dataLoadStatus) => {
    this.setState({ dataLoadStatus });
  };

  handleOnChangeARD = (ARD) => {
    this.setState({ ARD });
  };

  handleOnARDClose = () => {
    this.setState({ ARD: null });
  };
  //#endregion Handle

  //#region Function
  navigateTo = (link) => {
    this.props.navigate("/" + link);
  };

  onFormLoad = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "GetDashboardDetail",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
    };
    fetchDashboard(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing(res.data.msgType, res.data.message);
        let PurchaseTotalInvoice = 0,
          SalesTotalInvoice = 0;
        if (res.data.msgType === "success") {
          if (res.data.SalesCount) {
            SalesTotalInvoice = Number(res.data.SalesCount);
          }
          if (res.data.PurchaseCount) {
            PurchaseTotalInvoice = Number(res.data.PurchaseCount);
          }
          this.setState({
            SalesData: {
              ...this.state.SalesData,
              TotalInvoice: SalesTotalInvoice,
            },
            PurchaseData: {
              ...this.state.PurchaseData,
              TotalInvoice: PurchaseTotalInvoice,
            },
          });
        }
      })
      .catch((err) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occured in onFormLoad.\n\n" + err
        );
      });
  };

  onSalesListClick = (SalesList, SalesEntry, PurchaseList, PurchaseEntry) => {
    {
      this.props.navigateTo(SalesList, SalesEntry, PurchaseList, PurchaseEntry);
    }
  };

  onSalesReportClick = () => {
    if (
      this.props.userPrivilege.Sales != "" &&
      this.props.userPrivilege.Sales != undefined &&
      this.props.userPrivilege.Sales != "R"
    ) {
      this.navigateTo("SalesReport");
    }
  };

  onPurchaseReportClick = () => {
    if (
      this.props.userPrivilege.Purchase != "" &&
      this.props.userPrivilege.Purchase != undefined &&
      this.props.userPrivilege.Purchase != "R"
    ) {
      this.navigateTo("PurchaseReport");
    }
  };
  //#endregion Function

  render() {
    return (
      <div>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          direction={"column"}
          spacing={4}
        >
          <Grid item>
            <Card style={{ backgroundColor: "#d6effc" }}>
              <CardHeader
                avatar={
                  <Typography
                    variant="h5"
                    style={{
                      color: "#05699d",
                      fontWeight: "600",
                      letterSpacing: 2,
                    }}
                  >
                    SALES
                  </Typography>
                }
                action={
                  <CardActions>
                    {this.props.userPrivilege.Sales != "" &&
                    this.props.userPrivilege.Sales != undefined ? (
                      <>
                        <IconButton
                          aria-label="settings"
                          onClick={() => this.onSalesListClick("SalesList")}
                          title="Sales List"
                        >
                          <ArticleIcon sx={{ color: "#05699d" }} />
                        </IconButton>
                        <IconButton
                          aria-label="settings"
                          onClick={() => this.onSalesListClick("Salesnew")}
                          title="Sales Entry"
                        >
                          <AddCircleIcon sx={{ color: "#05699d" }} />
                        </IconButton>
                      </>
                    ) : (
                      ""
                    )}
                  </CardActions>
                }
              />
              <CardContent>
                <Grid
                  container
                  direction={"row"}
                  justifyContent={"center"}
                  spacing={3}
                >
                  <Grid item>
                    <Box
                      sx={{
                        width: 245,
                        //   height: 300,
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "white",
                      }}
                    >
                      <Divider
                        orientation="vertical"
                        sx={{
                          height: "auto",
                          width: "6px",
                          backgroundColor: "#05699d",
                          // display: "block",
                        }}
                      />
                      {/* <CardContent> */}
                      <Box
                        sx={{
                          flexDirection: "column",
                          margin: "auto",
                          marginLeft: "15px",
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          Pending Invoice
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "20px",
                            fontWeight: "600",
                          }}
                        >
                          {this.state.SalesData.PendingInvoice}
                        </Typography>
                        {/* </CardContent> */}
                      </Box>

                      <CardContent>
                        <CardMedia
                          component="img"
                          alt="green iguana"
                          sx={{ width: 45 }}
                          image={sale1}
                        />
                      </CardContent>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box
                      sx={{
                        width: 245,
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "white",
                      }}
                    >
                      <Divider
                        orientation="vertical"
                        sx={{
                          height: "auto",
                          width: "6px",
                          backgroundColor: "#05699d",
                          display: "block",
                        }}
                      />
                      {/* <CardContent> */}
                      <Box
                        sx={{
                          flexDirection: "column",
                          margin: "auto",
                          marginLeft: "15px",
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          Total Invoice
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "20px",
                            fontWeight: "600",
                          }}
                        >
                          {this.state.SalesData.TotalInvoice}
                        </Typography>
                        {/* </CardContent> */}
                      </Box>
                      <CardContent>
                        <CardMedia
                          component="img"
                          alt="green iguana"
                          sx={{ width: 45 }}
                          image={sale2}
                        />
                      </CardContent>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box
                      sx={{
                        width: 245,
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "white",
                      }}
                      onClick={this.onSalesReportClick}
                    >
                      <Divider
                        orientation="vertical"
                        sx={{
                          height: "auto",
                          width: "6px",
                          backgroundColor: "#05699d",
                          display: "block",
                        }}
                      />
                      {/* <CardContent> */}
                      <Box
                        sx={{
                          flexDirection: "column",
                          margin: "auto",
                          marginLeft: "15px",
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          Sales Reports
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "20px",
                            fontWeight: "600",
                          }}
                        ></Typography>
                        {/* </CardContent> */}
                      </Box>
                      <CardContent>
                        <CardMedia
                          component="img"
                          alt="green iguana"
                          sx={{ width: 45 }}
                          image={sale3}
                        />
                      </CardContent>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item>
            <Card style={{ backgroundColor: "#c7fdd3" }}>
              <CardHeader
                avatar={
                  <Typography
                    variant="h5"
                    style={{
                      color: "#198e33",
                      fontWeight: "600",
                      letterSpacing: 2,
                    }}
                  >
                    PURCHASE
                  </Typography>
                }
                action={
                  <CardActions>
                    {this.props.userPrivilege.Purchase != "" &&
                    this.props.userPrivilege.Purchase != undefined ? (
                      <>
                        <IconButton
                          aria-label="settings"
                          onClick={() => this.onSalesListClick("PurchaseList")}
                          title="Purchase List"
                        >
                          <ArticleIcon sx={{ color: "#198e33" }} />
                        </IconButton>
                        <IconButton
                          aria-label="settings"
                          onClick={() => this.onSalesListClick("Purchasenew")}
                          title="Purchase Entry"
                        >
                          <AddCircleIcon sx={{ color: "#198e33" }} />
                        </IconButton>
                      </>
                    ) : (
                      ""
                    )}
                  </CardActions>
                }
              />
              <CardContent>
                <Grid
                  container
                  direction={"row"}
                  justifyContent={"center"}
                  spacing={3}
                >
                  <Grid item>
                    <Box
                      sx={{
                        width: 245,
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "white",
                      }}
                    >
                      <Divider
                        orientation="vertical"
                        sx={{
                          height: "auto",
                          width: "6px",
                          backgroundColor: "#198e33",
                          display: "block",
                        }}
                      />
                      {/* <CardContent> */}
                      <Box
                        sx={{
                          flexDirection: "column",
                          margin: "auto",
                          marginLeft: "15px",
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          Pending Invoice
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "20px",
                            fontWeight: "600",
                          }}
                        >
                          {this.state.PurchaseData.PendingInvoice}
                        </Typography>
                        {/* </CardContent> */}
                      </Box>
                      <CardContent>
                        <CardMedia
                          component="img"
                          alt="green iguana"
                          sx={{ width: 45 }}
                          image={purchase1}
                        />
                      </CardContent>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box
                      sx={{
                        width: 245,
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "white",
                      }}
                    >
                      <Divider
                        orientation="vertical"
                        sx={{
                          height: "auto",
                          width: "6px",
                          backgroundColor: "#198e33",
                          display: "block",
                        }}
                      />
                      {/* <CardContent> */}
                      <Box
                        sx={{
                          flexDirection: "column",
                          margin: "auto",
                          marginLeft: "15px",
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          Total Invoice
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "20px",
                            fontWeight: "600",
                          }}
                        >
                          {this.state.PurchaseData.TotalInvoice}
                        </Typography>
                        {/* </CardContent> */}
                      </Box>
                      <CardContent>
                        <CardMedia
                          component="img"
                          alt="green iguana"
                          sx={{ width: 45 }}
                          image={purchase2}
                        />
                      </CardContent>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box
                      sx={{
                        width: 245,
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "white",
                      }}
                      onClick={this.onPurchaseReportClick}
                    >
                      <Divider
                        orientation="vertical"
                        sx={{
                          height: "auto",
                          width: "6px",
                          backgroundColor: "#198e33",
                          display: "block",
                        }}
                      />
                      {/* <CardContent> */}
                      <Box
                        sx={{
                          flexDirection: "column",
                          margin: "auto",
                          marginLeft: "15px",
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          Purchase Reports
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "20px",
                            fontWeight: "600",
                          }}
                        ></Typography>
                        {/* </CardContent> */}
                      </Box>
                      <CardContent>
                        <CardMedia
                          component="img"
                          alt="green iguana"
                          sx={{ width: 45 }}
                          image={purchase3}
                        />
                      </CardContent>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </div>
    );
  }
}
export default withRouter(
  connect(
    mapStatetoProps,
    mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps
  )(HOCVerifyIsUser(HOCReduxData(HoCtToastContainer(Dashboard))))
);
